import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DataArrayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"data_array"}/>
}
